<table mat-table [dataSource]="rows" class="margin-t-20 margin-b-20">

    <ng-container matColumnDef="originColumn">
      <th mat-header-cell *matHeaderCellDef>{{ 'DRIVER_IMPORT.originColumn' | translate }}</th>
      <td mat-cell *matCellDef="let column">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'DRIVER_IMPORT.selectColumn' | translate }}</mat-label>
          <mat-select [(ngModel)]="column.originColumn" (selectionChange)="onRowUpdate(column)" panelClass="import-dropdown">
            <mat-option *ngFor="let item of dropDownItemsOrigin" [value]="item.value">{{ item.name }}</mat-option>
            <mat-option (click)="onAddNewColumn()" class="add-new-field">
              <div class="material-icons">add_box</div>
              <span>{{ 'DRIVER_IMPORT.addNewField' | translate }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="destinationColumn">
      <th mat-header-cell *matHeaderCellDef>{{ 'DRIVER_IMPORT.destinationColumn' | translate }}</th>
      <td mat-cell *matCellDef="let column">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'DRIVER_IMPORT.selectColumn' | translate }}</mat-label>
          <mat-select [(ngModel)]="column.destinationColumn" (selectionChange)="onRowUpdate(column)" panelClass="import-dropdown">
            <mat-option *ngFor="let item of dropDownItemsDestination" [value]="item.value">{{ item.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field id="dateDropDown" appearance="outline" class="extra-format-info" *ngIf="checkDateField(column.destinationColumn)" >
          <mat-label>{{ 'DRIVER_IMPORT.selectDateFormat' | translate }}</mat-label>
          <mat-select [(ngModel)]="column.dateFormat" (selectionChange)="onRowUpdate(column)">
            <mat-option *ngFor="let item of formatOptions(column.destinationColumn)" [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field id="nameFormatDropDown" appearance="fill" class="extra-format-info"
          *ngIf="checkNameField(column.destinationColumn)">
          <mat-label>{{ 'DRIVER_IMPORT.selectNameFormat' | translate }}</mat-label>
          <mat-select [(ngModel)]="column.nameFormat" (selectionChange)="onRowUpdate(column)">
            <mat-option *ngFor="let item of formatOptions(column.destinationColumn)" [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let column">
        <button mat-button color="warn" (click)="onDeleteRow(column)">
          <mat-icon>delete_forever</mat-icon>
        </button>
      </td>
    </ng-container>
  

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  
  </table>
  
  <!-- Button to Add New Row -->
  <button mat-button (click)="onAddNewRow()">
    <mat-icon>add</mat-icon> {{ 'DRIVER_IMPORT.addNewRow' | translate }}
  </button>
  